<template>
<div class="chapter">
<div class="inner_page">
<h3 class="ChTitle"><a id="page_xii"></a><span class="underline">FROM UNCLE JOHN #1</span></h3>
<p class="noindent1s"><span><span class="dropcap">L</span><b>ate in 1987,</b> when I first took the idea for a bathroom reader to New York publishers, it seemed the series might never even get started. Times were different: The idea of a book designed for the bathroom made editors squeamish. I got a unanimous “No thanks,” complete with disgusted grimaces. But when I got back home to California a few weeks later, a message was waiting: St. Martin’s Press had decided to give it a try.</span></p>
<p class="indent"><span>The good news for BR fans is that St. Martin’s had really just bought the <i>concept</i>; they didn’t care about the <i>contents.</i> So we were free to include anything we wanted. Whatever subjects fascinated us found their way onto the pages—stories about old TV shows and pop music, doo-wop syllables, oddities of American history, quotes from Einstein. A friend showed me a page of church newsletter bloopers her mother had sent her. Voila! It became part of the book. We read a story about some crazed fan sneaking into Elvis’ hotel room and using his toothbrush. In it went. And so on.</span></p>
<p class="indent"><span>Putting the first <i>Bathroom Reader</i> together was so much fun that I could hardly believe someone was actually paying me—which may be why it was an instant success. It also helped that I found Michael Brunsfeld, the talented illustrator who’s created almost all the BR covers, and Andy Sohn, who designed the now-familiar page format. And it helped that St. Martin’s Press provided bookstores with cardboard displays shaped like toilets. (Wish I still had one of those.) Who could resist that?</span></p>
<p class="indent"><span>Now, 25 years later, my silly idea is an institution. That’s a weird enough story to include in a book like…well, this one.</span></p>
<p class="centert"><span><i>Go with the Flow!</i></span></p>
<p class="righta"><span><b>—John Javna</b></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Frontmatter002.vue?5023f4d6